<template>
  <div class="dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item v-if="item.permission" title="敏感权限列表" name="2">
        <pre class="note">{{ item.permission }}</pre>
      </el-collapse-item>
      <el-collapse-item title="更新内容" name="1">
        <pre class="note">{{ item.note }}</pre>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: 'DialogBody',
  props: {
    item: {}
  },
  data() {
    return {
      activeNames: ['1']
    };
  },
}
</script>


<style lang="scss" scoped>

.dialog {

  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-size: 1rem;
    color: #666666;
    line-height: 28px;
    text-align: left;
  }
}

/deep/ .el-collapse-item__header {
  font-size: 1rem;
}
</style>
